import { Tooltip } from '@material-ui/core';
import CSS from 'csstype';
import React, { useState } from 'react';

import { RenderType } from '~/src/dash/components/list-table';
import { Text, TextButton } from '~/src/dash/publicaUI';

export const RENDERTYPE_MEDIUM_WIDTH: Record<RenderType, number> = {
  '': 120,
  normal: 160,
  bold: 240,
  namelink: 240,
  namelink_returnsnameid: 240,
  overunderlink: 240,
  activeswitch: 120,
  deleteclone: 120,
  copy: 120,
  delete: 120,
  bignumber: 240,
  percent: 240,
  date: 240,
  activeswitchmodal: 240,
  clone: 120,
  modal: 160,
  editable: 240,
  editable1: 240,
  editable2: 240,
  play: 240,
  playCreativeURL: 240,
  vastPlay: 240,
  namelink_withtooltip: 240,
  modal2: 160,
  truncate: 240,
  truncate2: 240,
  modal3: 160,
  superuserswitch: 120,
  currency: 240,
  markedflag: 240,
  currencyOrUndefined: 240,
  textchips: 240,
  icons: 240,
  actions: 120,
};

export const getListTableMediumResponsiveColumnWidth = (
  renderType: RenderType,
  colWidth: string | undefined,
  isMediumSizeOrBelow: boolean,
) => {
  return isMediumSizeOrBelow ? `${RENDERTYPE_MEDIUM_WIDTH[renderType]}px` : colWidth || '';
};

export const getRenderTypeMediumStyle = (renderType: RenderType): CSS.Properties => {
  switch (renderType) {
    case 'namelink':
      return {
        display: 'inline-block',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
      };
    default:
      return {} as CSS.Properties;
  }
};
interface IRenderTypeTruncateProps {
  name: string;
  truncatedName: string;
}

export const RenderTypeTruncate = ({ name, truncatedName }: IRenderTypeTruncateProps) => {
  const [isMaximized, setIsMaximized] = useState(false);
  const countCommas = name.split('),').length - 1;
  const morethanOneIABCat = countCommas > 0;
  const truncatedNameEllipsis = truncatedName + '...';
  const [isOpen, setIsOpen] = useState(false);
  const tooltip = isMaximized ? 'Click to Collapse All' : 'Click to View All';
  return (
    <Tooltip arrow={true} open={isOpen} title={morethanOneIABCat ? tooltip : ''}>
      <div
        onClick={() => setIsOpen(false)}
        onMouseOver={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
      >
        {morethanOneIABCat ? (
          <TextButton onClick={() => setIsMaximized(!isMaximized)}>
            <Text small style={{ textAlign: 'left' }}>
              {!isMaximized
                ? truncatedNameEllipsis
                : name.split('),').map((i, key) => {
                    return <div key={key}>{countCommas !== key ? i + ')' : i}</div>;
                  })}
            </Text>
          </TextButton>
        ) : (
          <Text small style={{ textAlign: 'left' }}>
            {name}
          </Text>
        )}
      </div>
    </Tooltip>
  );
};
